import { render, staticRenderFns } from "./AllocatedTopups.vue?vue&type=template&id=1e8a2501&scoped=true&"
import script from "./AllocatedTopups.vue?vue&type=script&lang=js&"
export * from "./AllocatedTopups.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedTopups.vue?vue&type=style&index=0&id=1e8a2501&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a2501",
  null
  
)

export default component.exports